import { Illustration } from 'modules/common/components/Illustrations/Illustration'
import { IconConsultFaqs } from 'modules/common/components/_icons/icons'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { useCountryExternalLinks } from 'modules/common/hooks/useCountryExternalLinks'
import { useTranslation } from 'modules/common/hooks/useTranslation'

export const SponsorshipFaqContainer = () => {
  const { t } = useTranslation('settings-components')
  const externalLinks = useCountryExternalLinks()

  return (
    <div className="flex w-full flex-col items-center space-y-6 rounded-2xl border border-info-100 p-12">
      <Illustration name="info-look" size="m" />
      <h2>{t('sponsorshipFaqContainer.title')}</h2>
      <Button
        variant="secondary"
        color="default"
        className="min-w-[400px]"
        icon={<IconConsultFaqs />}
        href={externalLinks.sponsorshipFAQ}
      >
        {t('sponsorshipFaqContainer.button')}
      </Button>
    </div>
  )
}
